import { requestAndParse, requestSuccessful } from '../request';

const setForgottenPassword = async (newPassword: string, token: string) => {
    const route = 'auth/set-password';
    const payload = {
        password: newPassword,
    };

    const response = await requestAndParse(route, payload, 'POST', token);

    return {
        success: requestSuccessful(response),
        message: response.body?.message as string | undefined,
    };
};

export default setForgottenPassword;
